module.exports = __webpack_public_path__ + "agency-academy.ae5729286bd63b39103d.jpg";